export default __webpack_public_path__ + "static/OradeaTechHub_logo@2x-4b89e7f8b3a21be39ea8bd1a30aa130e.png";